import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const RiskDisclaimerBanner = ({ onDismiss }) => {
  const [isDismissed, setIsDismissed] = React.useState(false);

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) onDismiss();
  };

  if (isDismissed) return null;

  return (
    <div style={{ background: 'rgba(255,193,7,0.06)', borderBottom: '1px solid rgba(255,193,7,0.15)' }} className="relative z-50">
      <div className="container mx-auto px-4 md:px-6 py-2.5">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 flex-1">
            <AlertTriangle className="w-3.5 h-3.5 text-[#ffc107] flex-shrink-0" />
            <p className="text-[#aaa] text-[11px] leading-tight">
              <span className="text-[#ffc107] font-semibold">Risk Warning: </span>
              Trading cryptocurrencies, forex, and other financial instruments involves substantial risk.{' '}
              <Link to="/risk-disclaimer" className="text-[#ffc107] underline underline-offset-2 hover:text-white transition-colors">
                Read full disclaimer
              </Link>
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="text-[#555] hover:text-[#ffc107] transition-colors flex-shrink-0"
            aria-label="Dismiss warning"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default RiskDisclaimerBanner;
